import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=38f6227a&"
import script from "./overview.vue?vue&type=script&lang=ts&"
export * from "./overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports